// extracted by mini-css-extract-plugin
export default {"tag":"tags_tag__Xxhm0","is_loading":"tags_is_loading__vGQP+"};